import React from 'react';
import Translation from '../../../translation/translation';

function DimensionsMissing(props) {
    return (
        <span className="statusbar__current-status">
            <span className="statusbar__current-status-label">
                <Translation translationKey={getTranslationKeyForDimensionsMissing(props)} />
            </span>
            {' '}
            <span className="statusbar__current-status-missing-dimensions">
                {missingDimensionToFullDimensionText(props)}
            </span>
        </span>
    );
}

function dimensionsMissingPropTypesCheck(props) {
    if (!props.width && !props.height && !props.diameter) {
        return new Error('`DimensionsMissing` expects to have at least one of the following properties: width, height, diameter');
    }
}

DimensionsMissing.propTypes = {
    width: dimensionsMissingPropTypesCheck,
    height: dimensionsMissingPropTypesCheck,
    diameter: dimensionsMissingPropTypesCheck
};

function missingDimensionToFullDimensionText(sizes) {
    sizes = sizes || {};

    if (sizes.width && !sizes.height && !sizes.diameter) {
        return sizes.width + ' ...';
    }

    if (!sizes.width && sizes.height && !sizes.diameter) {
        return '... ' + sizes.height + ' ...';
    }

    if (!sizes.width && !sizes.height && sizes.diameter) {
        return '... R' + sizes.diameter;
    }

    if (sizes.width && sizes.height && !sizes.diameter) {
        return sizes.width + ' ' + sizes.height + ' ...';
    }

    if (sizes.width && !sizes.height && sizes.diameter) {
        return sizes.width + ' ... R' + sizes.diameter;
    }

    if (!sizes.width && sizes.height && sizes.diameter) {
        return '... ' + sizes.height + ' R' + sizes.diameter;
    }

    console.error('`missingDimensionToFullDimensionText` expects at least one of the three sizes: width, height or diameter. None given');
}

function getTranslationKeyForDimensionsMissing(sizes) {
    sizes = sizes || {};

    if (sizes.width && !sizes.height && !sizes.diameter) {
        return 'catalog-current-status-missing-dimensions-label-width';
    }

    if (!sizes.width && sizes.height && !sizes.diameter) {
        return 'catalog-current-status-missing-dimensions-label-height';
    }

    if (!sizes.width && !sizes.height && sizes.diameter) {
        return 'catalog-current-status-missing-dimensions-label-diameter';
    }

    if (sizes.width && sizes.height && !sizes.diameter) {
        return 'catalog-current-status-missing-dimensions-label-width-height';
    }

    if (sizes.width && !sizes.height && sizes.diameter) {
        return 'catalog-current-status-missing-dimensions-label-width-diameter';
    }

    if (!sizes.width && sizes.height && sizes.diameter) {
        return 'catalog-current-status-missing-dimensions-label-height-diameter';
    }

    console.error('`getTranslationKeyForDimensionsMissing` expects at least one of the three sizes: width, height or diameter. None given');
}

export default DimensionsMissing;
export {
    missingDimensionToFullDimensionText,
    getTranslationKeyForDimensionsMissing
};